namespace $ {

	$mol_style_define( $shm_hitalama_settings_agent, {
		Config: {
			width: $mol_style_unit.rem( 40 ),
		},
		Config_fields: {
			flex: { grow: 1 },
		},
		Check_row: {
			align: { items: 'center' },
			flex: { wrap: 'wrap' },
		},
		Check_status: {
			'[status]': {
				pending: { color: $shm_theme.active },
				success: { color: $shm_theme.success },
				error: { color: $shm_theme.error },
			},
		},
	} )

}
